// src/api/usersApi.js
import { api } from "./client";

export const usersApi = {
  // Org-scoped, ungated beyond authentication — used to power search/select
  // pickers for anyone who needs to look a colleague up by name/email, not
  // just full user administrators. search/page/pageSize are applied
  // server-side (presentation/identity/user_controller.py::list_users) —
  // response is {items, total, page, page_size, total_pages}, not a bare array.
  list: ({ search, page = 1, pageSize = 20 } = {}) => {
    const params = { page, page_size: pageSize };
    if (search) params.search = search;
    return api.get("/users", { params });
  },
};
